const info = '<p class="first">湖南政府采购网“公共信箱”</p> <p class="second">是湖南政府采购网站面向社会公众设立的专用电子信箱。您的来信我们将按程序予以办理，并在一定时限内向您反馈处理结果。</p>';
class HNMail {
  constructor () {
    this.imgTitle = $('.img-info');
    this.init();
  }
  init () {
    let here = this;
    here.imgTitle.html(info);
  }
}


module.exports = HNMail;
